import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { withRouter } from 'react-router-dom';
import CommToolContext from '../../common/comm_tool_context';
import { getIPSProject, getIpsTeamRoleMembers } from '../../../api';
import ProjectTabRoutes from '../../../components/ProjectTabsList/ProjectTabRoutes';
import AssetInstall from '../Asset/IpsAssetInstall';
import IPSAsset from '../Asset/IpsAssetRemoval';
import IPSProjectTeam from '../ipsproject_team';
import DataTrackerTabContainer from './DataTrackerTabContainer';

const { TabPane } = Tabs;
function DataTrackersTabs(props) {
  const {
    project,
    context,
    history,
    match,
    status,
    teamMembersList,
    allDropDownOptions,
  } = props;

  const { setActiveProject } = context;
  useEffect(() => {
    setActiveProject(project);
  }, []);

  const [teamMembers, setTeamMembers] = useState(teamMembersList);
  const [currentProject, setCurrentProject] = useState(project);

  let projectInfo = {
    bpid: project.bpid,
    workOrder: project.workOrder,
    stationName: project.stationName,
  };
  async function developTabsOnclick(key) {
    switch (key) {
      case 'details':
        const teamMembers = getIpsTeamRoleMembers(projectInfo);

        const updatedProjectList = getIPSProject(projectInfo);
            let result = await Promise.allSettled([teamMembers, updatedProjectList]);
            
        setTeamMembers(result[0].value);
        setCurrentProject(result[1].value);
        setActiveProject(result[1].value);
           

        break;
        return null;
        break;
    }
  }

  return (
    <CommToolContext.Consumer>
      {(context) => (
        <div className='container-fluid'>
          <ProjectTabRoutes
            project={project}
            context={context}
            status={status}
          />
          <h4>
            <b>{project.stationName}</b>
          </h4>
          <Tabs
            defaultActiveKey='details'
            className='nav-B'
            onChange={developTabsOnclick}
            onTabClick={(key) => {
              let encodedStationName = encodeURIComponent(project.stationName)
              history.push({
                pathname: `/${status}/${encodedStationName}/${project.bpid}/${project.workOrder}/${key}`,
                
              })
            }}
            type='card'
            activeKey={match.params.tabId || 'details'}
          >
            <TabPane tab='Data Tracker' key='details'>
              <DataTrackerTabContainer
                project={currentProject}
                setCurrentProject={setCurrentProject}
                status={status}
                allDropDownOptions={allDropDownOptions}
                context={context}
                history={history}
                teamMembers={teamMembers}
                // allComments={allComments}
              />
            </TabPane>
            <TabPane tab='Asset Installation' key='assetinstallation'>
              <AssetInstall project={currentProject} />
            </TabPane>
            <TabPane tab='Asset Removal' key='assetRemoval'>
              <IPSAsset project={currentProject} />
            </TabPane>
            <TabPane tab='Team' key='team'>
              <IPSProjectTeam
                project={currentProject}
                context={context}
                status={status}
              />
            </TabPane>
          </Tabs>
        </div>
      )}
    </CommToolContext.Consumer>
  );
}

// DataTrackersTabs.contextType = DataTrackersTabs;
export default withRouter(DataTrackersTabs);
